import React from 'react';
import './Window.css';

class Window extends React.Component {

  render() {
    //console.log('DECA!',this.props);

    return (
      <div className="Window">
        <div className="Window__overlay">
          <div className="Window__box">
            {this.props.close &&
              <div className="Window__close" onClick={this.props.history.goBack} >
                <i className="fa fa-close"></i>
              </div>}
            <h2 className="Window__title">{this.props.title}</h2>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Window;



// WEBPACK FOOTER //
// ./src/Window.js